import React from 'react';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { dateFormatter } from '@app/shared/formatters';
import styles from './under-maintenance.module.scss';
import { useLocale } from '@app/core/hooks/useLocale';
import { useMaintenanceMode } from '../inputs/opm-inputs-2/utils/useMaintenanceMode';
import { calculateTimeDifferenceInHours } from '@app/shared/helpers/maintenance/date-time-calculations';
import { selectMaintenanceModeSettings } from '@app/core/store/ui-values-slice-selectors';

const PARENT_CLASSNAME = 'maintenance-banner';

const MaintenanceBanner: React.FC = () => {
  const { l } = useLocale();
  const maintenanceModeSettings = useAppSelector(selectMaintenanceModeSettings);

  const { renderBanner } = useMaintenanceMode();

  const formattedStartTime = maintenanceModeSettings.start
    ? dateFormatter(new Date(maintenanceModeSettings.start), {
        timeStyle: 'short',
      })
    : l('_NotAvailable');

  const formattedCompletionHours =
    maintenanceModeSettings.start && maintenanceModeSettings.end
      ? Math.ceil(
          calculateTimeDifferenceInHours(
            new Date(maintenanceModeSettings.start),
            new Date(maintenanceModeSettings.end)
          )
        )
      : null;

  const formattedCompletionTime =
    formattedCompletionHours !== null
      ? l('_Hours', { hours: formattedCompletionHours })
      : l('_NotAvailable');

  if (renderBanner) {
    return (
      <div className={styles[`${PARENT_CLASSNAME}__banner`]}>
        <div className={styles['text-content']}>
          <p>
            {l('_MaintenanceBannerMessage', {
              formattedStartTime,
              formattedCompletionTime,
              releaseVersion: maintenanceModeSettings.version,
            })}
          </p>
          <p>{l('_MaintenanceMessage')}</p>
          {maintenanceModeSettings.message && (
            <>
              <br />
              <p>{maintenanceModeSettings.message}</p>
            </>
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default MaintenanceBanner;
